import { createSelector } from 'reselect'

import { uiSelector } from '../../selectors'

const settingsSelector = createSelector(
  uiSelector,
  ui => ui.settings)

export {
  settingsSelector,
}



// WEBPACK FOOTER //
// ./src/ui/settings-and-tools/selectors.js